module.exports = __webpack_public_path__ + "static/img/video-cover.c8a91460.jpg";